/* The audit list (13-32), on the shell grid with a serif page head (D-13-15-2), the record page's language.
 * Purple is identity only; an overdue audit is amber, never red (D-13-15-4). */

.head {
  padding-top: 44px;
  margin-bottom: 22px;
}

.kicker {
  margin: 0 0 6px;
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--color-text-secondary);
}

.title {
  margin: 0;
  font-family: var(--serif);
  font-weight: 400;
  font-size: clamp(28px, 3.6vw, 40px);
  line-height: 1.12;
  color: var(--color-primary-dark);
}

.lede {
  margin: 10px 0 0;
  max-width: 62ch;
  font-size: 15px;
  line-height: 1.55;
  color: var(--color-text-secondary);
}

.headActions {
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.savedNote {
  margin: 14px 0 0;
  padding: 10px 14px;
  font-size: 14px;
  color: var(--teal-dark);
  background: var(--teal-soft);
  border-radius: var(--radius-md);
}

.schedule {
  margin-bottom: 24px;
  max-width: 720px;
}

.tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--line);
}

.tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 15px;
  background: none;
  border: none;
  border-radius: var(--radius-full);
  cursor: pointer;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-secondary);
}

.tab:hover {
  background-color: var(--lavender-light);
  color: var(--color-primary-dark);
}

.tab:focus-visible {
  outline: 2px solid var(--color-border-focus);
  outline-offset: 2px;
}

.tabActive,
.tabActive:hover {
  background-color: var(--lavender);
  color: var(--color-primary-dark);
}

.count {
  min-width: 22px;
  padding: 0 7px;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: var(--color-text-secondary);
  background: var(--color-bg-card);
  border: 1px solid var(--line);
  border-radius: var(--radius-full);
}

.tabLate .count {
  color: var(--amber-dark);
  background: var(--amber-soft);
  border-color: var(--amber-line);
}

.list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.row {
  display: grid;
  grid-template-columns: 84px minmax(0, 1fr) minmax(150px, auto) minmax(150px, 220px);
  gap: 6px 18px;
  align-items: baseline;
  padding: 14px 18px;
  background: var(--color-bg-card);
  border: 1px solid var(--line);
  border-radius: 14px;
}

.rowLate {
  border-left: 4px solid var(--amber);
}

.ref {
  font-size: 13px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--color-primary-dark);
  text-decoration: none;
}

.what {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.name {
  font-size: 15px;
  font-weight: 600;
  color: var(--color-text);
  text-decoration: none;
  overflow-wrap: anywhere;
}

.name:hover,
.ref:hover {
  text-decoration: underline;
}

.meta {
  font-size: 13px;
  color: var(--color-text-secondary);
}

.centro {
  display: inline-block;
  text-wrap: nowrap;
  margin-left: 8px;
  padding: 1px 8px;
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text-secondary);
  background: var(--color-bg);
  border: 1px solid var(--line);
  border-radius: var(--radius-full);
}

.when {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 13.5px;
  color: var(--color-text);
}

.late {
  color: var(--amber-dark);
  font-weight: 600;
}

.who {
  font-size: 13px;
  color: var(--color-text-secondary);
  overflow-wrap: anywhere;
}

.muted {
  font-size: 12.8px;
  color: var(--color-text-muted);
}

.empty {
  margin: 0;
  padding: 18px;
  font-size: 14px;
  color: var(--color-text-secondary);
  background: var(--color-bg);
  border: 1px dashed var(--line);
  border-radius: 14px;
}

.loading {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 24px 0;
  color: var(--color-text-secondary);
}

.failure {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  padding: 10px 14px;
  font-size: 14px;
  color: var(--amber-dark);
  background: var(--amber-soft);
  border: 1px solid var(--amber-line);
  border-radius: var(--radius-md);
}

.failure p {
  margin: 0;
}

@media (max-width: 720px) {
  .row {
    grid-template-columns: 1fr;
    gap: 4px;
  }
}
